import React, { useState } from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { SxStyle } from '../../../types';

export type TimeMachineSelectPath = 'app-configs' | 'teams' | 'user';
const TimeMachineSelectList: TimeMachineSelectPath[] = ['app-configs', 'teams', 'user'];

const styles: SxStyle = {
  formControl: {
    width: '200px',
  },
};

interface Props {
  onSelectedType: (path: TimeMachineSelectPath) => void;
}

const TimeMachineSelect = ({ onSelectedType }: Props) => {
  const [selectedType, setSelectedType] = useState<TimeMachineSelectPath>('app-configs');

  const onChange = (event: SelectChangeEvent) => {
    const newSelectedType = event.target.value as TimeMachineSelectPath;
    setSelectedType(newSelectedType);
    onSelectedType(newSelectedType);
  };

  return (
    <FormControl sx={styles.formControl}>
      <InputLabel>{'Välj collection'}</InputLabel>
      <Select size="small" value={selectedType} label="app-configs" onChange={onChange}>
        {TimeMachineSelectList.map((value) => (
          <MenuItem key={value} value={value}>
            {value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TimeMachineSelect;
